import { useEffect, useState } from "react";
import { fetchPresence, pingPresence } from "@/lib/api";
import { useAuth } from "@/lib/AuthContext";

const label = (minutes) => {
  if (minutes == null) return "Hors ligne";
  if (minutes < 60) return `Hors ligne · il y a ${Math.max(minutes, 1)} min`;
  const h = Math.round(minutes / 60);
  if (h < 24) return `Hors ligne · il y a ${h} h`;
  return `Hors ligne · il y a ${Math.round(h / 24)} j`;
};

// Pastille verte (en ligne, pulse) / rouge (hors ligne) — style Leboncoin.
export const PresenceDot = ({ userId, showLabel = true }) => {
  const [presence, setPresence] = useState(null);

  useEffect(() => {
    if (!userId) return;
    let active = true;
    const load = () => fetchPresence(userId).then((d) => { if (active) setPresence(d); }).catch(() => {});
    load();
    const t = setInterval(load, 45000);
    return () => { active = false; clearInterval(t); };
  }, [userId]);

  if (!presence) return null;

  return (
    <span className="inline-flex items-center gap-1.5" data-testid={`presence-${presence.is_online ? "online" : "offline"}`}>
      <span className="relative flex h-2.5 w-2.5">
        {presence.is_online && (
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
        )}
        <span className={`relative inline-flex rounded-full h-2.5 w-2.5 ${presence.is_online ? "bg-emerald-500" : "bg-red-400"}`} />
      </span>
      {showLabel && (
        <span className={`text-[11px] font-semibold ${presence.is_online ? "text-emerald-600" : "text-[var(--ink-soft)]"}`}>
          {presence.is_online ? "En ligne" : label(presence.last_seen_minutes)}
        </span>
      )}
    </span>
  );
};

// Composant invisible : signale la presence de l'utilisateur connecte (ping 60s + retour d'onglet).
export const PresenceHeartbeat = () => {
  const { user } = useAuth();
  useEffect(() => {
    if (!user) return;
    const ping = () => pingPresence().catch(() => {});
    ping();
    const t = setInterval(ping, 60000);
    const onVisible = () => { if (document.visibilityState === "visible") ping(); };
    document.addEventListener("visibilitychange", onVisible);
    return () => { clearInterval(t); document.removeEventListener("visibilitychange", onVisible); };
  }, [user]);
  return null;
};
